import { CarEBoxLocation } from '../../types';

import { carsActions } from '../reducer';

export const updateSelectedCar = (
  carEBoxLocation?: CarEBoxLocation
) => carsActions.setSelectedEBoxLocation(carEBoxLocation);
